// @flow

import qs from 'query-string'

export function getQueryParams (): Object {
  return qs.parse(window.location.search)
}

export function getQuery (queryName: string): any {
  const parsed = qs.parse(window.location.search)
  if (!(queryName in parsed)) throw new Error(`Query name ${queryName} is missing`)

  return parsed[queryName]
}

export function getQueryFallback (queryName: string, fallbackValue: any): any {
  const parsed = qs.parse(window.location.search)
  if (!(queryName in parsed)) return fallbackValue

  return parsed[queryName]
}

export function addQueryToURL (url: string, query: any): string {
  return qs.stringifyUrl({
    url,
    query
  })
}
